export default __webpack_public_path__ + "static/media/elon2x.410a254e.png";